var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchLinePrimary1616 = function SvgSearchLinePrimary1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    fillRule: "evenodd",
    d: "M7.259 1.958a5.3 5.3 0 1 0 0 10.602 5.3 5.3 0 0 0 0-10.602M.708 7.26a6.55 6.55 0 1 1 13.102 0 6.55 6.55 0 0 1-13.102 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    fillRule: "evenodd",
    d: "M11.002 11.003a.625.625 0 0 1 .884 0l3.223 3.222a.625.625 0 1 1-.884.884l-3.223-3.223a.625.625 0 0 1 0-.883",
    clipRule: "evenodd"
  })));
};
export default SvgSearchLinePrimary1616;